module.exports = __webpack_public_path__ + "static/img/ilu-procure.4a53d64.jpg";